export default __webpack_public_path__ + "static/twitterSummaryX-d7241d7f798dcf545e30b0dde828581d.jpg";